









































interface curAccount {
	addtax: string;
	accountBookId: number;
	startPeriod: string;
	endPeriod: string;
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import EITQuarterTableVue from "../components/EITQuarter/EITQuarterTable.vue";
import SideNavVue from "../components/Declaration/SideNav.vue";

import { mapGetters } from "vuex";
@Component({
	...mapGetters(["accountBook"]),
	components: {
		"month-selector": MonthSelectorVue,
		"income-table": EITQuarterTableVue,
		"side-nave": SideNavVue
	}
})
export default class EITQuarter extends Vue {
	curAccount: curAccount = {
		addtax: this.$store.state.accountBook.addtax,
		accountBookId: this.$store.state.accountBook.id,
		startPeriod: "",
		endPeriod: ""
	};
	activeTab: string = "";

	mounted() {
		this.activeTab = "incomeTaxDeclarationMain";
	}

	// 选择时间
	changeDate(val: string) {
		this.curAccount.startPeriod = val;
		this.curAccount.endPeriod = val;
		this.fetchData();
	}

	// 表格数据
	curData: any = null;
	fetchData(period?: string) {
		let start = this.curAccount.startPeriod,
			end = this.curAccount.endPeriod;
		// 主表
		if (this.activeTab === "incomeTaxDeclarationMain") {
			this.curData = null,
				Vue.axios
					.get(
						`enterpriseincometaxquartermain?accountBookId=${this.$store.state.accountBook.id}&period=${end}`
					)
					.then(res => {
						this.curData = res.data;
					});
		}
		// 附表一
		else if (this.activeTab === "incomeTaxDeclarationTwo") {
			this.curData = null,
				Vue.axios
					.get(
						`enterpriseincometaxquarterone?accountBookId=${this.$store.state.accountBook.id}&period=${end}`
					)
					.then(res => {
						this.curData = res.data;
					});
		}
		// 附表二
		else if (this.activeTab === "incomeTaxDeclarationThree") {
			this.curData = null,
				Vue.axios
					.get(
						`enterpriseincometaxquartertwo?accountBookId=${this.$store.state.accountBook.id}&period=${end}`
					)
					.then(res => {
						this.curData = res.data;
					});
		}
		// 附表三
		else if (this.activeTab === "incomeTaxDeclarationFour") {
			this.curData = null,
				Vue.axios
					.get(
						`enterpriseincometaxquarterthree?accountBookId=${this.$store.state.accountBook.id}&period=${end}`
					)
					.then(res => {
						this.curData = res.data;
					});
		}
		// 附表四
		else if (this.activeTab === "incomeTaxDeclarationFive") {
			this.curData = null,
				Vue.axios
					.get(
						`enterpriseincometaxquarterfour?accountBookId=${this.$store.state.accountBook.id}&period=${end}`
					)
					.then(res => {
						if (res.data.officeDate != "")
							res.data.officeDate = this.$utils.strToDate(res.data.officeDate);
						if (res.data.resignationDate != "")
							res.data.resignationDate = this.$utils.strToDate(
								res.data.resignationDate
							);
						if (res.data.transactionDate != "")
							res.data.transactionDate = this.$utils.strToDate(
								res.data.transactionDate
							);
						if (res.data.disposalDate != "")
							res.data.disposalDate = this.$utils.strToDate(
								res.data.disposalDate
							);
						if (res.data.achieveTenPercentDate != "")
							res.data.achieveTenPercentDate = this.$utils.strToDate(
								res.data.achieveTenPercentDate
							);
						this.curData = res.data;
					});
		}
		// 附表五
		else if (this.activeTab === "incomeTaxDeclarationSix") {
			this.curData = null,
				Vue.axios
					.get(
						`enterpriseincometaxquarterfive?accountBookId=${this.$store.state.accountBook.id}&period=${end}`
					)
					.then(res => {
						for (let i = 0; i < res.data.length; i++) {
							if (res.data[i].acquisitionDate != "") {
								res.data[i].acquisitionDate = this.$utils.strToDate(
									res.data[i].acquisitionDate
								);
							}
						}
						this.curData = res.data;
					});
		}
	}
	// 切换纳税申报表
	changeType(val: number) {
		if (val === 1) this.fetchData()
		else this.$router.push({ path: "/declaration" })
	}

	// 修改以前年度亏损额
	async editPrev() {
		const res: any = await this.$prompt("请输入以前年度亏损额", "修改", {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
            inputValue: this.curData.previousLoss
		});
		this.curData.previousLoss = res.value;
        this.curData.changeTypeName = "previousLoss";
		await Vue.axios.post(`enterpriseincometaxquartermain?accountBookId=${this.$store.state.accountBook.id}&period=${this.curAccount.startPeriod}`, this.curData);
        this.fetchData();
	}
}
